import React from "react";
import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import image1 from "../../../../Images/IPB/image1.png"
import image2 from "../../../../Images/IPB/image2.png"
import image3 from "../../../../Images/IPB/image3.png"
import image4 from "../../../../Images/IPB/image4.png"
import image5 from "../../../../Images/IPB/image5.png"
import image6 from "../../../../Images/IPB/image6.png"
import image7 from "../../../../Images/IPB/image7.png"
import image8 from "../../../../Images/IPB/image8.png"
import wave from "../../../../Images/aboutUsBg.jpg";
// import wave from "../../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../../CssStyle/commonCss";
import WaveBackground from "../../../../Component/WaveBackground";
import { ArrowForward } from "@mui/icons-material";

const IPB = () => {
  return (
    <Grid2 container spacing={"2rem"} >
     <WaveBackground menu={"Our Products"} title={"Internet Booking Platform"} description={"EBook Services And Events Easily With One Powerful Platform"}/>
    

      <Grid2 container justifyContent={"center"}>
      <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"0 3rem 3rem 3rem"},maxWidth:{xs:"auto",xl:"2000px"}}} alignItems={"center"} mt="-10%" >
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            <img src={image3} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},textAlign:{xs:"center",md:"left"},fontWeight:700,fontFamily:"inherit"}}>Internet Booking Platform  Web App</Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Internet Booking Platform </span> is a comprehensive online solution designed to simplify the process of booking various services through a unified, user-friendly platform. Whether it’s reserving accommodations, booking appointments, purchasing event tickets, or scheduling services, this platform aims to provide a seamless and efficient experience for users and service providers alike.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography>
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >User Management</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText> Service Listings</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Booking and Reservations</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Payment Processing</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Search and Filtering</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Admin and Provider Dashboard</ListItemText>
                </ListItem>
                
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
     <Grid2 container justifyContent={"center"} sx={{background:commonCss.backgroundGray}} >
     <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:"auto",md:"2000px"}}} alignItems={"center"}>
     <Grid2 size={{xs:12,md:6}} sx={{pl:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>ChatGPT said:
          We use an Internet Booking Platform  (IBP) system because it provides a streamlined and efficient way to manage bookings and reservations online
</Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>Why Use an IBP?
</Typography>
            
            {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:4,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Customers can book anytime from anywhere, increasing convenience and customer satisfaction.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Instantly updates availability and prevents double bookings.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Reduces manual work with automated confirmations, reminders, and payments.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Easy-to-use interfaces and quick booking processes improve user satisfaction.
                  </ListItemText>
                </ListItem>
            </List>
        </Grid2>
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-end"}}>
            <img src={image4} style={{width:'85%',height:"100%"}}/>
        </Grid2>
      
     </Grid2>
     </Grid2>
     <Grid2 container justifyContent={"center"}>
     <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:'auto',xl:"2000px"}}} alignItems={"center"}  >
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            <img src={image5} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>Benefits</Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1.1rem",
              fontWeight:400
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Enhanced user experience through intuitive navigation and fast booking.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Real-time updates to prevent double bookings and maintain accuracy.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Increased business visibility for service providers through a centralized platform.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Reduced booking errors and improved customer satisfaction.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Interactive dashboards</ListItemText>
                </ListItem>
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
     <Grid2 container justifyContent={"center"} sx={{background:commonCss.backgroundGray}}>
     <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"2rem"},maxWidth:{xs:"auto",xl:"2000px"}}} alignItems={"center"}  >
     <Grid2 size={{xs:12,md:6}} sx={{pl:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
     <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>Space Management Features</Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1.1rem",
              fontWeight:400
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Space Allocation & Leasing.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Space Utilization Analytics.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Maintenance & Service Requests.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Revenue and Payment Management.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Tenant Communication Hub.</ListItemText>
                </ListItem>
            </List>
        </Grid2>
       
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-end"}}>
            <img src={image6} style={{width:'85%',height:"100%"}}/>
        </Grid2>
     </Grid2>
     </Grid2>
     <Grid2 container justifyContent={"center"}>
     <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:"auto",md:"2000px"}}} alignItems={"center"}  >
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            <img src={image2} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>Advertisement Management Features</Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif',  
              fontSize:"1.1rem",
              fontWeight:400
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Ad Space Inventory Management.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Ad Campaign Management.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Advertising Analytics.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Multi-Channel Ad Management.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Advertiser Management</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Multi-Tenant Ad Management</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Ad Compliance & Approval Workflow</ListItemText>
                </ListItem>
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
    </Grid2>
  );
};

export default IPB;
